import React from "react";

import DupontButton from "components/DupontButton";

import RightArrowIcon from "assets/SvgIcon/RightArrowIcon";

import "./index.scss";

const TextWithRightArrow = props => {
  const { text, onClick, disabled, fontStyle } = props;
  return (
    <span className="text-with-arrow" disabled={disabled}>
      <DupontButton customClass={`text-with-arrow--button ${fontStyle}`} type="tertiary" onClick={onClick} disabled={disabled}>
        {text} <RightArrowIcon disabled={disabled} />
      </DupontButton>
    </span>
  );
};

export default TextWithRightArrow;
